<script lang="ts">
  import { page } from "$app/stores";
  import { cartGet } from "$lib/store/cart-context";
  import { fly, fade } from "svelte/transition";
  import LoginForm from "./step-1.svelte";
  import RegistrationForm from "./step-2.svelte";
  import ProgressDialog from "./step-3.svelte";
  import PasswordLoginForm from "./pass-login.svelte";
  import { Views, screenSize } from "$lib/store/detect-view";
  import { closeModal, onBeforeClose } from "@thehood/svlib";

  // provided by <Modals />
  export let isOpen: boolean | unknown = false;
  export let email = "";

  let atCheckout = $page.url.pathname.indexOf("checkout") > -1 || false;
  let prefillMail = Object.fromEntries($page.url.searchParams.entries());
  let error = "";
  // Modal state
  export let step = 1;

  // // Modal state
  export let onBeforeCloseCallback: () => void = () => {
    cartGet();
  };
  // custom
  export let conditionalOnCloseCallback: (reOpenMenu: boolean) => void = () => {};
  // // Modal state
  export let backdropClick = true;
  let blockClose = true;
  let backToMenuFlag = false;
  // block close functionality
  // If click on email, redirect opening login modal and fill it with the email
  if (prefillMail?.customerEmail) {
    email = prefillMail.customerEmail;
  }

  onBeforeClose(() => {
    !blockClose && onBeforeCloseCallback();
  });

  function close() {
    blockClose = false;
    closeModal();
  }
  function backToMenu(ev: Event) {
    ev.preventDefault();
    ev.stopImmediatePropagation();

    blockClose = false;
    backToMenuFlag = true;

    conditionalOnCloseCallback($screenSize === Views.DESKTOP);
    closeModal();
  }

  function showStep1(ev: Event) {
    ev.stopImmediatePropagation();
    step = 1;
  }
  function customTransitionIn(node: Element) {
    if ($screenSize !== Views.DESKTOP) {
      return fly(node, { x: "100%", y: 0, opacity: 100 });
    }
    return fade(node);
  }

  function customTransitionOut(node: Element) {
    if ($screenSize !== Views.DESKTOP && !backToMenuFlag) {
      return fly(node, { duration: 1000, x: 0, y: "-100%", opacity: 100 });
    }

    return fade(node);
  }
</script>

<div role="dialog" class="modal" class:backdropClick in:customTransitionIn out:customTransitionOut>
  {#if isOpen}
    <div class="contents">
      <div class="background" />
      <button class="btn-close" on:click={close} />

      {#if step === 1}
        <LoginForm bind:step bind:atCheckout bind:lastInput={email} bind:error>
          <!-- <button class="btn-back" on:click={backToMenu} /> -->
        </LoginForm>
      {:else if step === 2}
        <RegistrationForm bind:step bind:email>
          <button class="btn-back" on:click={showStep1} />
        </RegistrationForm>
      {:else if step === 4}
        <PasswordLoginForm bind:step bind:email>
          <button class="btn-back" on:click={showStep1} />
        </PasswordLoginForm>
      {:else}
        <ProgressDialog bind:error bind:step bind:blockClose />
        <!-- <ProgressDialog bind:step bind:blockClose>
          <button class="btn-back" on:click={backToMenu} />
        </ProgressDialog> -->
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .modal {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: var(--z2);

    /* allow click-through to backdrop */
    &.backdropClick {
      pointer-events: none;
    }
    @include desktop {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .contents {
    border-radius: 0.375em;
    padding: 5.69em 2.62em 2.92em 2.37em;
    background: transparent;
    pointer-events: auto;
    position: relative;
    @include tablet {
      margin: auto;
      width: 90%;
    }
    @include desktop {
      padding: 2.31em 2.92em 2.92em 4.15em;
      max-width: 45em;
    }

    .background {
      background: linear-gradient(180deg, #e9ebff 0%, #fff4fc 100%);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      -webkit-clip-path: polygon(2% 100%, 0 89%, 0 0, 100% 0, 100% 100%);
      clip-path: polygon(2% 100%, 0 89%, 0 0, 100% 0, 100% 100%);
      border-bottom-right-radius: 0.3125em;
      border-bottom-left-radius: 1.625em 2.625em;
      @include desktop {
        -webkit-clip-path: unset;
        clip-path: unset;
        border-radius: unset;
      }
    }

    .btn-back {
      display: inline;
      padding: 0.3125em 0;
      margin-right: 0.56em;
      background: url("../assets/arrow.svg") no-repeat center;
      background-size: contain;
      transform: rotate(180deg);
      border: none;

      width: 1.5em;
      height: 1.5em;
      @include desktop {
        display: none;
        // position: relative;
      }
    }

    .btn-close {
      background: url("@styles/assets/close-modal-x.svg") no-repeat center;
      border: none;
      position: absolute;
      right: 1.45em;
      top: 2.95em;
      width: 3.125em;
      height: 3.125em;
      z-index: var(--z1);
      @include desktop {
        // position: relative;
        top: 1.12em;
        right: 1em;
      }
    }
  }
</style>
